import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Modal,
    ProTableOt,
    Form,
    useProTableOt,
    Select,
    Tag,
    setParamsFilter
} from "../../ui/ot";
import AuthorisedCategoryValueForm from "./authorised_category_value_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';



const AuthorisedCategoryValueTable = ({
    keyPrefix = 'koha.authorized_category_values_management',
    rowKey = "id",
    showAllColumns = true,
    propsShowColumns,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [searchParams, setSearchParams] = useSearchParams();
    const searchCategory = searchParams.get('category')
    const [category, setCategory] = useState(searchCategory)
    const columns = [
        {
            title: t('authorised_value'),
            dataIndex: 'authorised_value',
            key: 'authorised_value',
            sorter: true,
            render: (text, record, index) => {
                return <>
                    <Typography.P>{record?.authorised_value}</Typography.P>
                </>
            }
        },
        {
            title: t('description'),
            dataIndex: 'description',
            key: 'description',
            sorter: true,
            ellipsis: true,
            render: (text, record, index) => {
                return <>
                    <Typography.P>{record?.description}</Typography.P>
                </>
            }
        },
        {
            title: t('description_opac'),
            dataIndex: 'description_opac', key: 'description_opac',
            sorter: true,
            ellipsis: true,
            render: (text, record, index) => {
                return <>
                    <Typography.P>{record?.description_opac}</Typography.P>
                </>
            }
        },
        {
            title: t('library_limitations'),
            dataIndex: 'branches',
            key: 'branches',
            align:"center",
            render: (text, record, index) => {
                if(record?.branches.length >0){
                    return <div>
                    {
                        (record?.branches || []).map((value, index) => {
                            return <div key={value.branchcode}>{value.branchname}</div>
                        })
                    }
                </div>
                }
                else{
                    return "-"
                }
                
            }
        },

    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['question_and_answer_data', 'title'])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get");

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const AuthorisedCategoryValueController = useCRUDController({
        apiRoute: "/koha/authorised_values", onFinish,
        onBefore
    })
    const AuthorisedCategoryController = useCRUDController({
        apiRoute: "/koha/authorised_values/category",
        // onFinish,
        // onBefore
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })


    useEffect(() => {
        checkAll();
        AuthorisedCategoryController.getData({
            size: 2000,
            cur_page: 1
        })
        libraryController.getData({})
    }, []);
    useEffect(() => {
        actionRef.current.reload()
    }, [category])
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>
        <Col span={24}>
            <Row align="middle" gutter={[8, 8]}>
                <Col>
                    <Typography.Title level={4}>{t('show_category')}:</Typography.Title>
                </Col>
                <Col>
                    <Select
                        value={category}
                        options={AuthorisedCategoryController?.ResponseData?.map((value) => {
                            return {
                                label: value?.category,
                                value: value?.category
                            }
                        })}
                        onChange={(val) => setCategory(val)}
                    >

                    </Select>
                </Col>
                <Col span={24}>
                    {AuthorisedCategoryController?.ResponseData
                        .filter((ele) => ele?.category === category)
                        .map((value) => {

                            return <Typography.P level={4}>{ReactHtmlParser(value?.description)}</Typography.P>
                        })}
                </Col>
            </Row>

        </Col>
        <Col span={24}>
            <ProTableOt
                initialValues={{ 
                    category: category,
                    branches:[]
                 }}
                searchParams={{ category }}
                formMode={true}
                actionRef={actionRef}
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return []
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get");
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        category: category
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return AuthorisedCategoryValueController.getData(newParams);
                    // return []
                }}

                pageSize={pageSize}
                // rowSelection={false}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }
                propsPatchProcess={(data) => {
                    let branches = data?.branches.map((ele) => {
                        return ele?.branchcode
                    })
                    return {
                        ...data,
                        lib: data?.description,
                        lib_opac: data?.description_opac,
                        branches: branches
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (data) => {
                            let libraryData = [...libraryController?.ResponseData].map((value) => {
                                return {
                                    branchcode: value?.branchcode,
                                    branchname: value?.branchname
                                }

                            })
                            let postData = data?.map((postValue) => {
                                return {
                                    ...postValue,
                                    branches: libraryData.filter((ele) => {
                                        return postValue?.branches.includes(ele?.branchcode)
                                    })
                                }
                            })
                            AuthorisedCategoryValueController.postData(postData)
                        },
                        patchData: (data) => {
                            let libraryData = [...libraryController?.ResponseData].map((value) => {
                                return {
                                    branchcode: value?.branchcode,
                                    branchname: value?.branchname
                                }

                            })
                            let patchData = data.map((postValue) => {
                                return {
                                    ...postValue,
                                    branches: libraryData.filter((ele) => {
                                        return postValue?.branches.includes(ele?.branchcode)
                                    })
                                }
                            })
                            AuthorisedCategoryValueController.patchData(patchData)
                        },
                        deleteData: (data) => {
                            let deleteData = data?.filter((ele) => {
                                return ele?.is_system === 0 && !ele?.description
                            })
                            if (deleteData) {
                                console.log({ deleteData })
                            }
                            AuthorisedCategoryValueController.deleteData(data)
                        }
                    }
                }}
                PropsPatchForm={<AuthorisedCategoryValueForm
                    libraryOption={libraryController?.ResponseData?.map((value) => {
                        return {
                            label: value?.branchname,
                            value: value?.branchcode,
                        }
                    })} />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch
                propsDelete
                propsPost
                propsWidth={1000}
                scroll={{
                    x: "100%",
                }}
            // isMultipleEdit={false}

            />
        </Col>
    </Row>)

}
const AuthorisedCategoryValue = ({
    keyPrefix = 'koha.authorized_category_values_management',

}) => {
    return (
        <Row>
            <Col span={24}>
                <AuthorisedCategoryValueTable keyPrefix={keyPrefix} />
            </Col>
        </Row>

    );
};
export { AuthorisedCategoryValueTable }
export default AuthorisedCategoryValue;
